import { Divider } from '@material-ui/core';
import { FeePaymentType, FeeType } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface PricingSpecFormFieldsProps {
  moreOptions: boolean;
}

export const PricingSpecFormFields = ({ moreOptions }: PricingSpecFormFieldsProps) => {
  const watcher = useFormContext()?.watch;

  const merchantFeeTypeWatcher = watcher('merchantFeeType');
  const setupFeeTypeWatcher = watcher('setupFeeType');

  return (
    <main style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <section
        style={{
          width: '100%',
          display: 'flex',
          gridGap: 24,
          overflowX: 'auto',
          paddingBottom: 32,
        }}
      >
        <>
          <div style={{ display: 'flex', minWidth: 'fit-content', gridGap: 24 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
              <FormSectionTitle tId={'PRINCIPAL'} />
              <NumberFormField autoFocus name={'minPrincipal'} label={'MINIMUM_AMOUNT'} valueUnit={'€'} />
              <NumberFormField name={'maxPrincipal'} label={'MAXIMUM_AMOUNT'} valueUnit={'€'} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
              <FormSectionTitle tId={'TERM'} />
              <NumberFormField name={'minTerm'} label={'minTerm'} type={'number'} allowDecimals={false} />
              <NumberFormField name={'maxTerm'} label={'maxTerm'} type={'number'} allowDecimals={false} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
              <FormSectionTitle tId={'ANNUAL_INTEREST_AND_DISCOUNT'} />
              <NumberFormField name={'annualInterest'} label={'annualInterest'} valueUnit={'%'} />
              <NumberFormField
                name={'merchantDiscountPercentage'}
                label={'merchantDiscountPercentage'}
                valueUnit={'%'}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
              <FormSectionTitle tId={'SETUP_FEE_COST'} />
              <div style={{ display: 'flex', gridGap: 24 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
                  <SelectFormField
                    name={'setupFeePaymentType'}
                    label="setupFeePaymentType"
                    selectOptions={Object.values(FeePaymentType).map((feePaymentType) => ({
                      value: feePaymentType,
                      display: <Text tId={`FEE_PAYMENT_TYPE_${feePaymentType}`} />,
                    }))}
                  />
                  <SelectFormField
                    name={'setupFeeType'}
                    label="setupFeeType"
                    selectOptions={Object.values(FeeType).map((feeType) => ({
                      value: feeType,
                      display: <Text tId={`FEE_TYPE_${feeType}`} />,
                    }))}
                  />
                </div>
                <NumberFormField
                  name={'setupFeeValue'}
                  label={'setupFeeValue'}
                  valueUnit={setupFeeTypeWatcher === FeeType.FIX_AMOUNT ? '€' : '%'}
                />
              </div>
            </div>
          </div>
          {moreOptions && (
            <div style={{ display: 'flex', minWidth: 'fit-content', gridGap: 24 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
                <FormSectionTitle tId={'GRACE_PERIOD'} />
                <NumberFormField name={'gracePeriod'} label={'gracePeriod'} type={'number'} allowDecimals={false} />
                <NumberFormField name={'gracePercentage'} label={'gracePercentage'} valueUnit={'%'} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
                <FormSectionTitle tId={'MERCHANT_FEE_COMMISSION'} />
                <SelectFormField
                  name={'merchantFeeType'}
                  label="merchantFeeType"
                  selectOptions={Object.values(FeeType).map((feeType) => ({
                    value: feeType,
                    display: <Text tId={`FEE_TYPE_${feeType}`} />,
                  }))}
                />
                <NumberFormField
                  name={'merchantFeeValue'}
                  label={'merchantFeeValue'}
                  valueUnit={merchantFeeTypeWatcher === FeeType.FIX_AMOUNT ? '€' : '%'}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
                <FormSectionTitle tId={'REGISTRATION'} />
                <NumberFormField
                  name={'yearsSinceAutoRegistrationMin'}
                  label={'yearsSinceAutoRegistrationMin'}
                  type={'text'}
                  allowDecimals={false}
                />
                <NumberFormField
                  name={'yearsSinceAutoRegistrationMax'}
                  label={'yearsSinceAutoRegistrationMax'}
                  type={'text'}
                  allowDecimals={false}
                />
              </div>
            </div>
          )}
        </>
      </section>
    </main>
  );
};

const FormSectionTitle = ({ tId }: { tId: string }) => {
  return (
    <>
      <Font variant={'body2'}>
        <Text tId={tId} strong />
      </Font>
      <Divider light />
    </>
  );
};
